/**
 ** Session Slider
 **/
import {Paper} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import Slider from 'react-slick';

const data = [
    <React.Fragment key='first'>
        <h3>Text recognition and Document conversion</h3>
        <dl>
            <li>OCR (printed text recognition) and ICR (hand-printed text)</li>
            <li> convert image/PDF to text</li>
        </dl>
        <h3>Digitising Archives</h3>
        <dl>
            <li>output files has the same layout as in original file</li>
            <li>ability to save document as searchable PDF, PDF/A or text format</li>
            <li>input file can be with unlimited pages count</li>
        </dl>
        <h3>Web Interface</h3>
        <dl>
            <li>manage your files from anywhere from any device</li>
            <li>search and filter your documents</li>
            <li>export accounting documents to Xero, QuickBooks etc…</li>
        </dl>
    </React.Fragment>,
    <React.Fragment key='second'>
        <h3>Extract Data From Any Document to Automate Your Business</h3>
        <dl>
            <li>invoices</li>
            <li>bank statements</li>
            <li>insurance claims</li>
            <li>purchase orders</li>
            <li>packaging lists</li>
            <li>delivery notes</li>
            <li>PDF reports</li>
            <li>tax forms</li>
            <li>drawings</li>
            <li>checks</li>
            <li>any other document or form</li>
        </dl>
    </React.Fragment>,
];

const SessionSlider = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        swipe: true,
        pauseOnHover: true,
        autoplaySpeed: 5000,
        touchMove: true,
        swipeToSlide: true,
        draggable: true,
    };

    return (
        <Paper className="session-slider p-15">
            <Slider {...settings}>
                {data.map((el, key) => (
                    <div key={key}>
                        <Grid item xs={12}>
                            {el}
                        </Grid>
                    </div>
                ))}
            </Slider>
        </Paper>
    );
};

export default SessionSlider;